import React from 'react'
import { useIntl } from 'react-intl'
import { useMe } from 'contexts/me'
import { getEmailAddress } from 'utilities/person'
import Message from 'components/message'

const ExportAbsenceSlowMessage = () => {
    const { formatMessage } = useIntl()
    const { me } = useMe()

    return (
        <Message
            type="success"
            message={formatMessage({
                id: 'absence_export_success_message',
                defaultMessage: 'Generating the export may take several minutes. We will email <strong>{email}</strong> with the report attached when it’s ready.'
            }, { email: getEmailAddress(me) })} />
    )
}

export default ExportAbsenceSlowMessage